import { normalizeText } from './helpers'

export default {
  value: {
    type: [Array, Object, String, Number, Boolean],
    default: () => null,
    note: 'value for "v-model".'
  },
  title: {
    type: String,
    default: ''
  },
  items: {
    type: [Array, String],
    required: true,
    note: 'array of suggestions (data fetched from backend, etc).'
  },
  itemsValueCheckBox: {
    type: [Array, String],
    required: false,
    note: 'Array value check box'
  },
  itemText: {
    type: String,
    default: null,
    note: 'property in item for text.'
  },
  itemValue: {
    type: String,
    default: null,
    note: 'property in item for value.'
  },
  placeholder: {
    type: String,
    default: null,
    note: 'placeholder for input.'
  },
  loading: {
    type: Boolean,
    default: false,
    note: 'display the loading indicator.'
  },
  disabled: {
    type: Boolean,
    default: false,
    note: 'disable the select.'
  },
  readonly: {
    type: Boolean,
    default: false,
    note: 'readonly state.'
  },
  filter: {
    type: Function,
    default: (item, queryText, itemText) => {
      const hasValue = val => val != null ? val : ''

      const text = hasValue(normalizeText(itemText))
      const query = hasValue(normalizeText(queryText))

      return text.toString()
        .toLowerCase()
        .indexOf(query.toString().toLowerCase()) > -1
    },
    note: 'filter function for search.'
  },
  searchText: {
    type: String,
    default: '',
    note: 'search string for input, you can use this with ".sync" modifier.'
  },
  inputElCustomAttributes: {
    type: Object,
    default: () => ({}),
    note: 'you can pass your attributes to the input element. Note: the attributes that are used by the component itself inside are not available, for example, "style".'
  },
  disableSearch: {
    type: Boolean,
    default: false,
    note: 'disable search input element.'
  },
  disableFilteringBySearch: {
    type: Boolean,
    default: false,
    note: 'disable filtering by search (you can use search for manually getting items).'
  },
  resetSearchOnBlur: {
    type: Boolean,
    default: true,
    note: 'reset search on blur event.'
  },
  allowMobileScroll: {
    type: Boolean,
    default: true,
    note: 'allow scrolling to an item on mobile devices.'
  },
  arrowsDisableInstantSelection: {
    type: Boolean,
    default: true,
    note: 'disable auto select when up or down with key arrow.'
  },
  menuItemsMaxHeight: {
    type: String,
    default: '120px',
    note: 'max menu height (any css value).'
  },
  eventEmitter: {
    type: Object,
    note: 'Observer pattern, helps manage events from parent to child.'
  },
  scrollItemsLimit: {
    type: Number,
    default: 20,
    note: 'the initial limit of the displayed items to scroll. So that there are not many elements in the scrolling at the beginning. Also see scrollItemsLimitAddAfterScroll prop.'
  },
  scrollItemsLimitAddAfterScroll: {
    type: Number,
    default: 10,
    note: 'the number of items added to the scrollItemsLimit prop after scrolling to the end of the scroll. Also see scrollItemsLimitAddAfterScroll prop.'
  },
  disableFirstItemSelectOnEnter: {
    type: Boolean,
    default: false,
    note: 'disable the selection of the first item from the list of items in menu when to press enter (when no item is selected).'
  },
  scrollToItemIfNeeded: {
    type: Boolean,
    default: true,
    note: 'to scroll to an item if it has moved beyond the scroll bar.'
  },
  inputStyles: {
    type: Object,
    default: () => ({}),
    note: 'custom styles for the input field. You can specify dynamic styles.'
  },
  inputForTextClass: {
    type: [Array, String, Object],
    default: () => '',
    note: 'custom "class" attribute for the input field. You can specify dynamic class.'
  },
  errorMessage: {
    type: String,
    default: null
  },
  successful: {
    type: Boolean,
    default: false,
    note: 'does the component have a successful state. If true, then apply green colors.'
  },
  size: {
    type: String,
    note: 'sets size'
  },
  colorText: {
    type: String,
    default: '#60656C'
  },
  onlyNumber: {
    type: Boolean,
    default: false
  },
  min: {
    type: String,
    required: false,
    default: ''
  },
  max: {
    type: String,
    required: false,
    default: ''
  },
  onlyText: {
    type: Boolean,
    required: false,
    default: false
  },
  onlyAlphaNum: {
    type: Boolean,
    required: false,
    default: false
  },
  checkBoxList: {
    type: Boolean,
    required: false,
    default: false
  }
}
